import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Izdajstvo",
  "description": "",
  "published": "2007-01-30T00:00:00.000Z",
  "redirect_from": ["/blog/izdajstvo/swizec/300"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Skozi mojo rano ljubezen do benda `}<a parentName="p" {...{
        "href": "http://www.dresdendolls.com/"
      }}>{`The Dresden Dolls`}</a>{` sem na youtube odkril`}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=vY2WLMf0F_c"
      }}>{` zanimiv video`}</a>{`, katerega so ustvarili skupaj s `}<a parentName="p" {...{
        "href": "http://www.panicatthedisco.com/"
      }}>{`Panic! At The Disco`}</a>{`, ki lepo pokaze razmerje med pantomimiki in emoti ... Malo e cudno, vendar sem preprican, da se globoko v sebi zavedajo, da so v resnici oboji enaki.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      